// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"AccordionSection_accordionContainer__P9q-x","accordionTitle":"AccordionSection_accordionTitle__3DBAW","hideSection":"AccordionSection_hideSection__3A7tY"};